import { Card, ErrorRetry } from '../ui';
import { useApiResource } from '../lib/useApiResource';

interface AuditRow {
  id: number;
  ts: string;
  actor: string;
  action: string;
  entity: string;
  entity_id: string;
  detail: string;
}

export function AuditScreen() {
  const { data, status, error, reload } = useApiResource<AuditRow[]>('/api/audit');
  const rows = data ?? [];

  return (
    <Card title="رویدادها (چه‌کسی، چه‌زمانی، چه‌کاری)">
      {status === 'error' ? (
        <ErrorRetry error={error} onRetry={() => reload()} />
      ) : status === 'loading' ? (
        <p className="muted">در حال بارگذاری…</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>زمان</th>
              <th>کاربر</th>
              <th>عمل</th>
              <th>مورد</th>
              <th>جزئیات</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="empty" colSpan={5}>
                  رویدادی ثبت نشده است.
                </td>
              </tr>
            ) : (
              rows.map((a) => (
                <tr key={a.id}>
                  <td className="num">{new Date(a.ts).toLocaleString('fa-IR')}</td>
                  <td>{a.actor}</td>
                  <td>{a.action}</td>
                  <td>
                    {a.entity} {a.entity_id}
                  </td>
                  <td className="muted">{a.detail || '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </Card>
  );
}
